/**********************************************
  EXPANDERS EXPLAINED:

  Take a route from of the sitemap generation process,
  return a promise for thenable routes - to be flattened when the sitemap is generated

*//////////////////////////////////////////////

import logger from 'logger';
import config from 'config';
import ApiClient from 'utils/ApiClient';
import { uniqBy } from 'lodash';

import { slugifyName } from 'utils';
import baskets from 'utils/baskets.js';
import { categoryUrlRoot } from 'utils/ArticleUtils';

const { SITEMAP_BASKET_ARTICLE_LIMIT } = config.sitemap;

const client = new ApiClient();

export function newsArticleExpander(newsPath) {
  return function ({url, sitemap: { changefreq, priority }}) {
    const routeArray = [];
    const promiseStack = [];

    for (const basketPath of baskets) {
      promiseStack.push(
        client.get(config.api.common.loadArticleSummary, { params: { basketPath, limit: SITEMAP_BASKET_ARTICLE_LIMIT, offset: 0 }})
          .then(result => result)
          .catch(err => {
            logger.debug(err);
            return [];
          })
      );
    }

    return Promise.all(promiseStack)
      .then(results => {
        for (const res of results) {
          for (const {article_reference: { id }, category, title, last_updated} of res.articles) {
            if (categoryUrlRoot(category) == newsPath) {
              routeArray.push({
                url: url.replace(':title', slugifyName(title)).replace(':articleId', id),
                sitemap: {
                  changefreq,
                  priority,
                  lastmodISO: new Date(last_updated).toISOString()
                }
              });
            }
          }
        }
        // uniqBy de-dups URLS inside array of objects
        return uniqBy(routeArray, 'url');
      })
  }
}



// WEBPACK FOOTER //
// ./modules/News/sitemap-helper.js